import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import BaseMixer from "@/router/views/BaseMixer";
import { IPAWorkFlowStepsDTO } from "@/store/models/paWorkFlow/paWorkFlowStepsDTO";
import { Constant } from "@/store/constant";
let WorkFlowStepComponent = /** @class */ (() => {
    var _a;
    let WorkFlowStepComponent = class WorkFlowStepComponent extends Mixins(BaseMixer) {
        showStepConfig() {
            this.$emit("show-step-config", this.item);
        }
        get targetAudience() {
            return Constant.TargetAudiences;
        }
        get isClient() {
            return this.item.paStepTargetAudienceId.toString() === this.targetAudience.Client();
        }
        get isClientInterface() {
            return this.item.clientAssignmentApplicable;
        }
        created() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IPAWorkFlowStepsDTO !== "undefined" && IPAWorkFlowStepsDTO) === "function" ? _a : Object)
    ], WorkFlowStepComponent.prototype, "item", void 0);
    WorkFlowStepComponent = __decorate([
        Component({
            name: "WorkFlowStepComponent",
            components: {},
        })
    ], WorkFlowStepComponent);
    return WorkFlowStepComponent;
})();
export default WorkFlowStepComponent;
